/* eslint-disable */
import { login, logout, getInfo } from '@/api/auth';
import { getToken, setToken, removeToken } from '@/utils/auth';
import router, { resetRouter } from '@/router';

const state = () => ({
  id: null,
  token: getToken(),
  name: '',
  prenom: '',
  avatar: '',
  roles: [],
  permissions: [],
  isAdmin: false,
  // Côté de l'utilisateur ('extranet' | 'internal'), calculé par le serveur.
  // Le front le déduisait de la présence du rôle nommé « extranet client » dans
  // sa liste : ce raccourci casse dès qu'un second profil extranet existe, et il
  // casse du mauvais côté — le client se voyait servir le layout interne.
  scope: 'internal',
  extranet_routes: [],
});

const mutations = {
  SET_TOKEN(state, token) {
    state.token = token;
  },
  SET_USER_INFO(state, { id, name, prenom, avatar, roles, permissions, scope, extranet_routes }) {
    state.id = id;
    state.name = name;
    state.prenom = prenom;
    state.avatar = avatar;
    state.roles = roles;
    state.permissions = permissions;
    state.isAdmin = roles.includes('super admin');
    // Repli sur l'ancien test par nom tant qu'un backend antérieur peut répondre
    // sans le champ `scope` : front et back n'ont pas à être déployés ensemble.
    state.scope = scope || (roles.includes('extranet client') ? 'extranet' : 'internal');
    state.extranet_routes = extranet_routes || [];
  },
  RESET_STATE(state) {
    state.id = null;
    state.token = '';
    state.name = '';
    state.prenom = '';
    state.avatar = '';
    state.roles = [];
    state.permissions = [];
    state.isAdmin = false;
    state.scope = 'internal';
    state.extranet_routes = [];
  },
};

const getters = {
  roles: (state) => state.roles || [],
  isExtranet: (state) => state.scope === 'extranet',
  permissions: (state) => state.permissions || [],
  token: (state) => state.token,
  isAdmin: (state) => state.isadmin
};

const actions = {
  async login({ commit, dispatch, state }, { login: loginValue, password, source }) {
    const response = await login({ login: loginValue.trim(), password, source });
    const token = response.meta.access_token;
    commit('SET_TOKEN', token);
    setToken(token);

    // Si login Mobiluce : retourner le CSC + refresh_token pour le deep link
    if (source === 'mobiluce' && response.meta.csc) {
      return {
        source: 'mobiluce',
        csc: response.meta.csc,
        refresh_token: response.meta.refresh_token,
      };
    }

    // Flux standard : récupération des infos utilisateur
    const userInfo = await dispatch('getInfo');

    // Génération des routes dynamiques
    const roles = userInfo.roles || [];
    const permissions = userInfo.permissions || [];
    // `getInfo` vient de poser le côté dans le state (avec repli sur l'ancien
    // nom de rôle) : on le relit là plutôt que de le redéduire ici.
    const isExtranet = state.scope === 'extranet';
    const accessedRoutes = await dispatch(
      'permission/generateRoutes',
      { roles, permissions, isExtranet },
      { root: true }
    );

    accessedRoutes.forEach(route => router.addRoute(route));

    // Redirection
    const redirect = router.currentRoute.value.query.redirect || '/dashboard';
    router.replace(redirect);
  },

  async getInfo({ commit, state }) {
    const response = await getInfo(state.token);
    const { data } = response;

    if (!data) throw new Error('Échec de la récupération des informations utilisateur.');

    const { id, name, prenom, avatar, roles = [], permissions = [], scope, extranet_routes = [] } = data;

    commit('SET_USER_INFO', { id, name, prenom, avatar, roles, permissions, scope, extranet_routes });
    return data;
  },

  async logout({ commit }) {
    await logout(state.token);
    commit('RESET_STATE');
    removeToken();
    resetRouter();
  },

  resetToken({ commit }) {
    commit('RESET_STATE');
    removeToken();
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
